import { RouteMeta } from 'vue-router'

export const defaultMeta: RouteMeta = {
  authRequired: true,
  hideDistractions: false, // does not apply to local notifications
  liveChatEnabled: false,
  title: 'Jobscan',
  description: 'Optimize your resume for your next job.',
  robots: 'noindex',
}

const buildMeta = (options: RouteMeta = {}): RouteMeta => {
  /*
    Note: Empty object set as initial target to avoid modifying
    the defaultMeta object when building the routes object
  */
  return Object.assign({}, defaultMeta, options)
}

export default buildMeta
